/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/Navigation',[
    'jquery',
    'global/Logger',
    'plugins/clickMenu'
], function ($, Logger, clickMenu) {
    function init() {

        var $cloneNav = $(".navbarWrapper .navbar").clone();

        $cloneNav.prependTo(".mobile-hamburger").clickMenu({ landings: true }).addClass("mobile-nav");
        $(".navbarWrapper .main-nav").clickMenu({ landings: true });

        $(".siteHeader .header-nav").clone().appendTo(".main-nav.mobile-nav .cm-menu").wrap('<li></li>');

        $(".nav-toggle").on("click", function (e) {
            e.preventDefault();

            if ($(".cm-js-menu-active").length <= 0 && $(".cm-animate-out").length <= 0) {
                $('body').children(".main-nav").find(".toggle-menu").trigger("click");
                var winHeight = $('.site-container').height();
                $('body>.main-nav').height(winHeight);
                $('.mobile-nav .account').removeAttr('data-hijax');
                $('.mobile-nav .cartLink').removeAttr('data-hijax');
            }
        });

        //var $clonedSubs = $cloneNav.find(".cm-menu ul, .cm-menu .custom-sub");

//        $clonedSubs.each(function () {
//            var $sub = $(this),
//				$back = $("<a href='#' role='button' class='back'>&lt; Back</a>");
//
//            var $wrap = $sub.is(".custom-sub") ? $("<div class='back-wrap'></div>") : $("<li class='back-wrap'></li>");
//
//            if ($sub.parents(".custom-sub").length <= 0) {
//                $wrap.append($back);
//                $sub.prepend($wrap);
//                $back.on("click", function (e) {
//                    e.preventDefault();
//                    $sub.siblings(".has-sub").trigger("click");
//                });
//            }
//        });



    };


    // Initialize mainNavigation
    init();

    var Navigation = { init: init };

    Logger.debug('Navigation.js Loaded:', Navigation);

    return Navigation;
});


